<template>
  <!-- 校本抢课简单选课 -->
  <div class="choseCourse">
    <div class="fl" v-if="list">
      <van-sidebar v-model="activeKey" @change="getIndex">
        <van-sidebar-item
          v-for="item in list"
          :key="item.SubjectGroupID"
          :title="item.SubjectGroupName"
        ></van-sidebar-item>
      </van-sidebar>
    </div>
    <div class="content fr" style="margin-bottom: 65px;" v-if="list">
      <div class="content-header">
        <!-- <p>{{list[0].SubjectGroupName}}</p> -->
        <p>
          本次最少选
          <span>{{ minNum }}</span
          >门，最多选 <span>{{ maxNum }}</span
          >门
        </p>
      </div>
      <div class="content-main">
        <div class="course" v-for="item in list[activeKey].Courses" :key="item.AID">
          <div>
            <span>{{ item.SubjectName }}</span>
            <img :src="igmUrl" alt />
            <p class="teacher" v-if="item.TeacherName !== ''">教师名称：{{ item.TeacherName }}</p>
            <p class="current">当前已选：{{ item.SelectCount }}/{{ item.StudentLimitation }}人</p>
            <p class="current" v-if="IsSelectTableTime || Status === 0">
              上课时间：{{ item.TimesInfo }}
            </p>
            <div class="op-btn">
              <div
                class="introduce-btn"
                v-if="item.IsExistsCourseIntroduction"
                @click="lntroduce(item)"
              >
                课程介绍
              </div>
              <div>
                <div class="btn" v-if="!item.IsSelected">选择</div>
                <div class="btn2" v-if="item.IsSelected">已选</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const courseUrl = require('@/assets/csmsTimeTable/onlineCourseSelection/course-class-img.png')
export default {
  data() {
    return {
      igmUrl: courseUrl,
      activeKey: 0,
      index: 0,
      list: [],
      minNum: '',
      maxNum: '',
      Status: -1,
      IsSelectTableTime: true
    }
  },
  created() {
    this.IsSelectTableTime = JSON.parse(this.$route.query.IsSelectTableTime)
    this.Status = Number(this.$route.query.Status)
    this.getSubjec()
  },
  methods: {
    getIndex(_index) {
      this.activeKey = _index
    },
    // 课程介绍
    async lntroduce(item) {
      this.xy.loading()
      let res = await this.xyapi.get(
        `${this.$store.state.apiPath}/api/StudentOnLineSelectCourse/GetCourseIntroduction`,
        { classTableID: this.$route.query.classTableID, aid: item.AID, type: item.Type }
      )
      this.xy.unloading()
      if (res.success) {
        if (res.data.IsUrl) {
          window.open(res.data.Description)
        } else {
          this.$router.push({
            name: 'choseCourseSchoolLntroduce',
            query: {
              classTableID: this.$route.query.classTableID,
              introduce: item
            }
          })
        }
      }
    },
    async getSubjec() {
      let res = await this.xyapi.get(
        this.$store.state.apiPath + '/api/StudentOnLineSelectCourse/GetSchoolBasedGrabOnLineList',
        {
          classTableID: this.$route.query.classTableID,
          isShow: false,
          studentID: 0
        }
      )
      if (res.success) {
        if (res.data.Results.length) {
          this.list = res.data.Results
          this.minNum = res.data.MinOptionalCourse
          this.maxNum = res.data.MaxOptionalCourse
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.choseCourse {
  width: 100%;
  .van-sidebar-item--select {
    color: #323233;
    font-weight: 500;
    border-color: #4196ff;
  }
  .van-sidebar-item {
    border-bottom: 1px solid #e6e6e6;
    line-height: inherit;
  }
  .fl {
    width: 20%;
    background: rgba(249, 249, 249, 1);
    box-shadow: 0px 4px 8px 0px rgba(151, 151, 151, 0.2);
  }
  .fr {
    width: 78%;
    margin: 10px auto;
  }
  .content {
    background-color: #fff;
    .content-header {
      padding: 15px 0 20px 20px;
      height: 100px;
      width: 100%;
      background-image: url('./../../../../assets/csmsTimeTable/onlineCourseSelection/conheader.png');
      background-size: cover;
      line-height: 35px;
      p:nth-child(1) {
        font-size: 26px;
        color: rgba(51, 51, 51, 1);
      }
      p:nth-child(2) {
        font-size: 22px;
        color: rgba(153, 153, 153, 1);
      }
      p {
        span {
          color: #545efa;
          font-weight: bold;
        }
      }
    }
    .content-main {
      text-align: center;
      p:nth-child(1) {
        font-size: 28px;
        color: #1d2157;
        font-weight: bold;
      }
      p:nth-child(2) {
        font-size: 22px;
        color: rgba(153, 153, 153, 1);
        line-height: 35px;
      }
      p {
        span {
          color: #545efa;
          font-weight: bold;
        }
      }
      .course {
        // padding-left: 30px;
        // margin-top: 20px;
        // padding-top: 25px;
        padding: 25px 30px 0 30px;
        border-top: 1px solid #e6e6e6;
        text-align: left;
        // border-bottom: 1px solid #e6e6e6;
        .op-btn {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin: 8px 0;
          .introduce-btn {
            background: #4196ff;
            padding: 0 10px;
            height: 52px;
            border-radius: 26px;
            line-height: 52px;
            text-align: center;
            font-weight: normal;
            font-size: 24px;
            font-weight: 400;
            color: #fff;
          }
          .btn-disabled {
            background: #dddd;
          }
        }
        div {
          position: relative;
          // height: 150px;
          img {
            position: absolute;
            width: 58px;
            height: 64px;
            left: 0;
            top: 25%;
          }
          .teacher {
            // position: absolute;
            // left: 20%;
            // top: 30%;
            font-size: 28px;
            text-align: left;
            font-weight: normal;
            margin: 5px 0 5px 70px;
            color: #999999;
          }
          .current {
            // position: absolute;
            // left: 20%;
            // top: 50%;
            font-size: 22px;
            text-align: left;
            font-weight: normal;
            color: #999999;
            margin: 5px 0 5px 70px;
          }
          .btn {
            // position: absolute;
            // right: 5%;
            // top: 25%;
            width: 124px;
            height: 52px;
            border: 1px solid rgba(255, 149, 0, 1);
            box-shadow: 0px 4px 8px 0px rgba(228, 111, 86, 0.5);
            border-radius: 26px;
            line-height: 52px;
            text-align: center;
            font-weight: normal;
            font-size: 24px;
            font-weight: 400;
            color: rgba(246, 141, 5, 1);
          }
          .btn2 {
            // position: absolute;
            // right: 5%;
            // top: 25%;
            width: 124px;
            height: 52px;
            background: rgba(255, 149, 0, 1);
            box-shadow: 0px 4px 8px 0px rgba(228, 111, 86, 0.5);
            border-radius: 26px;
            line-height: 52px;
            text-align: center;
            font-weight: normal;
            font-size: 24px;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>
